import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import InstantQuote from 'shared/components/parameters/InstantQuote';
import Quantities from 'shared/components/parameters/Quantities';
import DoubleSidedSmt from 'shared/components/parameters/DoubleSidedSmt';
import LeadFree from 'shared/components/parameters/LeadFree';
import BomLineItems from 'shared/components/parameters/BomLineItems';
import ClassThreeInspection from 'shared/components/parameters/ClassThreeInspection';
import SMTPlacements from 'shared/components/parameters/SMTPlacements';
import BGAPlacements from 'shared/components/parameters/BGAPlacements';
import THTPlacements from 'shared/components/parameters/THTPlacements';
import QFNPlacements from 'shared/components/parameters/QFNPlacements';
import SpecialInstructions from 'shared/components/parameters/SpecialInstructions';

import { selectAssemblyDataForParameters } from 'shared/product_tabs/tab_assembly/slice/selectors';
import { changeParameter, updateValidatorFlag } from 'shared/product_tabs/tab_assembly/slice/assemblySlice';
import { doQuote } from 'shared/product_tabs/tab_assembly/slice/thunks';
import { validator } from 'shared/product_tabs/tab_assembly/slice/validator';
import { START } from 'shared/data/quoteSteps';

const Parameters = () => {
  const dispatch = useDispatch();
  const {
    parameters,
    loading,
    quoteStep,
    // eslint-disable-next-line no-unused-vars
    validatorFlag,
  } = useSelector(selectAssemblyDataForParameters);

  const onChangeParameter = (name, value) => {
    dispatch(changeParameter({ name, value }));
  };

  const props = {
    parameters,
    onChangeParameter,
    disabled: loading
  };

  const onQuoteRequest = () => {
    if (validator.allValid()) {
      validator.showMessages();
      dispatch(doQuote());
    } else {
      validator.showMessages();
      dispatch(updateValidatorFlag());
    }
  };

  return (
    <div>
      <div className="row">
        <div className="col-md-6">
          <h3 className="product-name">{Spree.translations.pcb_assembly}</h3>
        </div>
        <div className="col-md-6">
          <InstantQuote
            loading={loading}
            label={
              quoteStep !== START
                ? Spree.translations.requote
                : Spree.translations.quote
            }
            onQuoteRequest={onQuoteRequest} />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <Quantities
            {...props}
            errorMessage={validator.message(
              'Quantity',
              parameters.quantities,
              'group_required|group_numeric|group_min:1,num',
            )} />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <BomLineItems
            {...props}
            errorMessage={validator.message(
              'Bom Line Items',
              parameters.bom_line_items,
              'required|numeric|min:1',
            )} />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <SMTPlacements
            {...props}
            errorMessage={validator.message(
              'SMT Placements',
              parameters.smt,
              'required|numeric|min:0',
            )} />
        </div>
        <div className="col-md-6">
          <THTPlacements
            {...props}
            errorMessage={validator.message(
              'THT Placements',
              parameters.thru_hole,
              'required|numeric|min:0',
            )} />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <BGAPlacements
            {...props}
            errorMessage={validator.message(
              'BGA Placements',
              parameters.bga,
              'required|numeric|min:0',
            )} />
        </div>
        <div className="col-md-6">
          <QFNPlacements
            {...props}
            errorMessage={validator.message(
              'QFN Placements',
              parameters.qfn,
              'required|numeric|min:0',
            )} />
        </div>
      </div>
      <div className="row">
        <div className="col-6 col-md-12">
          <LeadFree {...props} />
        </div>
        <div className="col-6 col-md-12">
          <DoubleSidedSmt {...props} />
        </div>
        <div className="col-6 col-md-12">
          <ClassThreeInspection {...props} className="mt-4" />
        </div>
        <div className="col-12">
          <SpecialInstructions {...props} />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <InstantQuote
            loading={loading}
            label={
              quoteStep !== START
                ? Spree.translations.requote
                : Spree.translations.quote
            }
            onQuoteRequest={onQuoteRequest} />
        </div>
      </div>
    </div>
  );
};

export default Parameters;
